import React from "react"
import { Switch } from "react-router-dom"
import glamorous from "glamorous"
import HeaderTabLink from "components/HeaderTabLink"
import style from "utils/style"

const isActive = (mountPath, key, path) => {
  return key === 0
    ? (match, { pathname }) => pathname === mountPath || pathname === path
    : null
}

const getStructure = ({
  children,
  mountPath,
  newButtonText,
  newButtonLink,
}) => {
  const firstChild = React.cloneElement(children[0], { path: mountPath })

  return (
    <Container>
      <Tabs>
        {React.Children.map(children, ({ props: { title, path } }, key) => (
          <HeaderTabLink
            key={key}
            title={title}
            path={path}
            isActive={isActive(mountPath, key, path)}
          />
        ))}
      </Tabs>

      <Switch>
        {children.length > 1 ? [...children.slice(1), firstChild] : firstChild}
      </Switch>
    </Container>
  )
}

const HeaderTabContainer = props =>
  props.children.length < 1 ? <Tabs /> : getStructure(props)

export default HeaderTabContainer

export const Container = glamorous.div({
  height: "100%",
})

export const Tabs = glamorous.div({
  backgroundColor: style.colors.backgroundGray,
  display: "flex",
  alignItems: "center",
  minHeight: "63px",
  height: 0,

  borderColor: style.colors.mediumGray,
  overflowX: "auto",
  overflowY: "hidden",
  "::-webkit-scrollbar": {
    display: "none",
  },
  "@media print": {
    display: "none",
  },
})



// WEBPACK FOOTER //
// ./src/containers/HeaderTabContainer/index.js